if (!customElements.get('text-with-icons-slider')) {
  class TextWithIconsSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-text-icons-track]');
      this.items = Array.from(this.querySelectorAll('.text-with-icons__item'));
      this.previousButton = this.querySelector('[data-text-icons-prev]');
      this.nextButton = this.querySelector('[data-text-icons-next]');
      this.currentElement = this.querySelector('[data-text-icons-current]');
      this.totalElement = this.querySelector('[data-text-icons-total]');
      this.progressElement = this.querySelector('[data-text-icons-progress]');
      this.tabletMediaQuery = window.matchMedia('(max-width: 990px)');
      this.currentIndex = 0;
      this.scrollFrame = null;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handlePrevious = this.handlePrevious.bind(this);
      this.handleNext = this.handleNext.bind(this);
    }

    connectedCallback() {
      if (this.dataset.mobileCarousel !== 'true' || !this.track || this.items.length < 2) return;

      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.tabletMediaQuery.addEventListener('change', this.handleResize);

      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this.track);

      if (this.totalElement) this.totalElement.textContent = this.items.length;
      this.refresh();
    }

    disconnectedCallback() {
      if (!this.track) return;

      this.track.removeEventListener('scroll', this.handleScroll);
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.tabletMediaQuery.removeEventListener('change', this.handleResize);
      this.resizeObserver?.disconnect();

      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
    }

    handleScroll() {
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => {
        this.currentIndex = this.getClosestItemIndex();
        this.updateControls();
      });
    }

    handleResize() {
      this.refresh();
    }

    handlePrevious() {
      this.scrollToItem(this.currentIndex - 1);
    }

    handleNext() {
      this.scrollToItem(this.currentIndex + 1);
    }

    getClosestItemIndex() {
      return this.items.reduce((closestIndex, item, index) => {
        const currentDistance = Math.abs(item.offsetLeft - this.track.scrollLeft);
        const closestDistance = Math.abs(this.items[closestIndex].offsetLeft - this.track.scrollLeft);
        return currentDistance < closestDistance ? index : closestIndex;
      }, 0);
    }

    scrollToItem(index) {
      const nextIndex = Math.max(0, Math.min(index, this.items.length - 1));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollTo({
        left: this.items[nextIndex].offsetLeft,
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
    }

    refresh() {
      const hasOverflow = this.tabletMediaQuery.matches && this.track.scrollWidth > this.track.clientWidth + 1;
      this.classList.toggle('has-overflow', hasOverflow);

      if (!hasOverflow) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = this.getClosestItemIndex();
      }

      this.updateControls();
    }

    updateControls() {
      if (this.currentElement) this.currentElement.textContent = this.currentIndex + 1;
      if (this.progressElement) {
        this.progressElement.style.setProperty('--text-icons-progress', `${((this.currentIndex + 1) / this.items.length) * 100}%`);
      }
      if (this.previousButton) this.previousButton.disabled = this.currentIndex === 0;
      if (this.nextButton) this.nextButton.disabled = this.currentIndex === this.items.length - 1;
    }
  }

  customElements.define('text-with-icons-slider', TextWithIconsSlider);
}
